<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <SiteEditorRichTextField
    :model-value="block.data.html"
    @update:model-value="block.data.html = $event"
  />
</template>
